module.exports = __webpack_public_path__ + "static/media/abbiamo5.e40a3562.png";